import { useEffect, useRef, useState } from "react";
import { Sparkles } from "lucide-react";

const ANIMATION_MS = 3000;
const COOLDOWN_MS = 5000;

/**
 * Threshold-crossing celebration overlay. Renders for `ANIMATION_MS`, then
 * stays dormant for at least `COOLDOWN_MS` before another celebration can
 * fire — matches the "3s on / 5s off" budget agreed during planning.
 */
export function SparkleCelebration(props: { active: boolean; onComplete?: () => void }) {
  const [visible, setVisible] = useState(false);
  const cooldownUntilRef = useRef<number>(0);

  useEffect(() => {
    if (!props.active) return;
    const now = Date.now();
    if (now < cooldownUntilRef.current) return;
    cooldownUntilRef.current = now + ANIMATION_MS + COOLDOWN_MS;
    setVisible(true);
    const t = window.setTimeout(() => {
      setVisible(false);
      props.onComplete?.();
    }, ANIMATION_MS);
    return () => window.clearTimeout(t);
  }, [props.active, props]);

  if (!visible) return null;
  return (
    <span
      className="pointer-events-none absolute inset-0 flex items-center justify-center"
      aria-hidden="true"
    >
      <Sparkles className="h-10 w-10 animate-ping text-yellow-300/70 dark:text-yellow-400/60" />
    </span>
  );
}
